/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetCommonState400Response,
  GetRegistry404Response,
  Registration429Response,
  SearchInstructions422Response,
  SiteGetRegistry200Response,
  SiteRegistrySearch200Response,
} from '../models/index'
import {
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetRegistry404ResponseFromJSON,
  GetRegistry404ResponseToJSON,
  Registration429ResponseFromJSON,
  Registration429ResponseToJSON,
  SearchInstructions422ResponseFromJSON,
  SearchInstructions422ResponseToJSON,
  SiteGetRegistry200ResponseFromJSON,
  SiteGetRegistry200ResponseToJSON,
  SiteRegistrySearch200ResponseFromJSON,
  SiteRegistrySearch200ResponseToJSON,
} from '../models/index'

export interface SiteGetRegistryRequest {
  registryId: string
}

export interface SiteRegistrySearchRequest {
  registryType: string
  registrationOfficeCode: string
  name?: string
  mktuClasses?: Array<number>
}

/**
 * RegistrySearchSiteApi - interface
 *
 * @export
 * @interface RegistrySearchSiteApiInterface
 */
export interface RegistrySearchSiteApiInterface {
  /**
   * Данные реестра (свидетельства ТЗ) по пути для сайта: сокращённый набор полей (без заявок, документов и счётчиков). Защищён site-verify, лимит 15 запросов в минуту. Результат кешируется на 3 часа.
   * @summary Получить данные о товарном знаке (сайт)
   * @param {string} registryId Путь реестра: &lt;scope&gt;-&lt;база&gt;&lt;номер&gt;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistrySearchSiteApiInterface
   */
  siteGetRegistryRaw(
    requestParameters: SiteGetRegistryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SiteGetRegistry200Response>>

  /**
   * Данные реестра (свидетельства ТЗ) по пути для сайта: сокращённый набор полей (без заявок, документов и счётчиков). Защищён site-verify, лимит 15 запросов в минуту. Результат кешируется на 3 часа.
   * Получить данные о товарном знаке (сайт)
   */
  siteGetRegistry(
    requestParameters: SiteGetRegistryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SiteGetRegistry200Response>

  /**
   * Публичный поиск по реестрам для сайта (защищён site-verify, лимит 15 запросов в минуту). Из параметров поиска используются только name и mktuClasses; остальные параметры фиксированы: база — RUTM, страница 1, 12 результатов, скрывать недействующие. Валидируется полным контрактом RegistrySearchRequest (registrationOfficeCode обязателен).
   * @summary Поиск по реестрам (сайт)
   * @param {string} registryType Раздел поиска
   * @param {string} registrationOfficeCode Код страны регистрационного ведомства (только RU)
   * @param {string} [name] Наименование знака
   * @param {Array<number>} [mktuClasses] Классы МКТУ (1–45)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistrySearchSiteApiInterface
   */
  siteRegistrySearchRaw(
    requestParameters: SiteRegistrySearchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SiteRegistrySearch200Response>>

  /**
   * Публичный поиск по реестрам для сайта (защищён site-verify, лимит 15 запросов в минуту). Из параметров поиска используются только name и mktuClasses; остальные параметры фиксированы: база — RUTM, страница 1, 12 результатов, скрывать недействующие. Валидируется полным контрактом RegistrySearchRequest (registrationOfficeCode обязателен).
   * Поиск по реестрам (сайт)
   */
  siteRegistrySearch(
    requestParameters: SiteRegistrySearchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SiteRegistrySearch200Response>
}

/**
 *
 */
export class RegistrySearchSiteApi
  extends runtime.BaseAPI
  implements RegistrySearchSiteApiInterface
{
  /**
   * Данные реестра (свидетельства ТЗ) по пути для сайта: сокращённый набор полей (без заявок, документов и счётчиков). Защищён site-verify, лимит 15 запросов в минуту. Результат кешируется на 3 часа.
   * Получить данные о товарном знаке (сайт)
   */
  async siteGetRegistryRaw(
    requestParameters: SiteGetRegistryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SiteGetRegistry200Response>> {
    if (requestParameters['registryId'] == null) {
      throw new runtime.RequiredError(
        'registryId',
        'Required parameter "registryId" was null or undefined when calling siteGetRegistry().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/site/registry/{registryId}`.replace(
          `{${'registryId'}}`,
          encodeURIComponent(String(requestParameters['registryId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SiteGetRegistry200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Данные реестра (свидетельства ТЗ) по пути для сайта: сокращённый набор полей (без заявок, документов и счётчиков). Защищён site-verify, лимит 15 запросов в минуту. Результат кешируется на 3 часа.
   * Получить данные о товарном знаке (сайт)
   */
  async siteGetRegistry(
    requestParameters: SiteGetRegistryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SiteGetRegistry200Response> {
    const response = await this.siteGetRegistryRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Публичный поиск по реестрам для сайта (защищён site-verify, лимит 15 запросов в минуту). Из параметров поиска используются только name и mktuClasses; остальные параметры фиксированы: база — RUTM, страница 1, 12 результатов, скрывать недействующие. Валидируется полным контрактом RegistrySearchRequest (registrationOfficeCode обязателен).
   * Поиск по реестрам (сайт)
   */
  async siteRegistrySearchRaw(
    requestParameters: SiteRegistrySearchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SiteRegistrySearch200Response>> {
    if (requestParameters['registryType'] == null) {
      throw new runtime.RequiredError(
        'registryType',
        'Required parameter "registryType" was null or undefined when calling siteRegistrySearch().'
      )
    }

    if (requestParameters['registrationOfficeCode'] == null) {
      throw new runtime.RequiredError(
        'registrationOfficeCode',
        'Required parameter "registrationOfficeCode" was null or undefined when calling siteRegistrySearch().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['registrationOfficeCode'] != null) {
      queryParameters['registrationOfficeCode'] =
        requestParameters['registrationOfficeCode']
    }

    if (requestParameters['name'] != null) {
      queryParameters['name'] = requestParameters['name']
    }

    if (requestParameters['mktuClasses'] != null) {
      queryParameters['mktuClasses'] = requestParameters['mktuClasses']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/site/registry-search/{registryType}`.replace(
          `{${'registryType'}}`,
          encodeURIComponent(String(requestParameters['registryType']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SiteRegistrySearch200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Публичный поиск по реестрам для сайта (защищён site-verify, лимит 15 запросов в минуту). Из параметров поиска используются только name и mktuClasses; остальные параметры фиксированы: база — RUTM, страница 1, 12 результатов, скрывать недействующие. Валидируется полным контрактом RegistrySearchRequest (registrationOfficeCode обязателен).
   * Поиск по реестрам (сайт)
   */
  async siteRegistrySearch(
    requestParameters: SiteRegistrySearchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SiteRegistrySearch200Response> {
    const response = await this.siteRegistrySearchRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }
}
